import { render, staticRenderFns } from "./weChat.vue?vue&type=template&id=26bd2d36&scoped=true&"
import script from "./weChat.vue?vue&type=script&lang=js&"
export * from "./weChat.vue?vue&type=script&lang=js&"
import style0 from "./weChat.vue?vue&type=style&index=0&id=26bd2d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bd2d36",
  null
  
)

export default component.exports